module.exports = __webpack_public_path__ + "img/schedule_outline.41cc8230.svg";